<div class="container-fluid">
  <div class="row" style="display: flex">
    <mat-card appearance="outlined" class="col-md-12 card_container container-fluid" id="slice-settings"
      style="padding: 0px">
      <section class="top-section">
        <div class="form-column">
          <div class="form-container">
            <div class="form-label">Iteration</div>
            <div class="form-field">
              <app-job-slider [isMobile]="isMobile" label="Iteration" [upperLimit]="totalIteration" [lowerLimit]="1"
                [(value)]="iteration" (valueUpdated)="onIterationChange()"></app-job-slider>
            </div>
            <div class="form-label">Depth</div>
            <div class="form-field">
              <app-job-slider [isMobile]="isMobile" label="Depth" [upperLimit]="nx3" [lowerLimit]="1"
                [(value)]="sliceNum" (valueUpdated)="onDepthChange()"></app-job-slider>
            </div>
          </div>
        </div>
      </section>
      <mat-divider></mat-divider>
      <div class="row container-fluid" id="image-and-slice" style="margin: 0; padding: 0px">
        <div class="row shot-container container-fluid" style="margin: 0" id="depth-slice">
          @if (shotData) {
          <div id="shotsContainer" style="margin: 0; padding: 0" class="col-md-7">
            @if (loadingShots) {
            <div class="loading">
              <mat-progress-spinner mode="indeterminate" class="spinner" diameter="30"></mat-progress-spinner>
              <span class="loading-text">Loading Shots</span>
            </div>
            }
            @if (!shotData && !loadingShots) {
            <div class="row" class="error-message">
              <h3>No Shot Information Available!</h3>
            </div>
            }
            <div>
              <div class="row" style="
                  margin: 0;
                  padding: 0;
                  display: flex;
                  justify-content: flex-end;
                ">
                <h5 class="col-sm-5">
                  <div class="circle-grey"></div>
                  Iteration Shots: {{ unavailableShots }}
                </h5>
                <h5 class="col-sm-5">
                  <div class="circle-red"></div>
                  Dumped Shots: {{ availableShots }}
                </h5>
                <a class="shot-height-trigger" [matMenuTriggerFor]="heightMenu"><i
                    class="zmdi zmdi-hc-2x zmdi-more-vert" style="width: 20px; text-align: right"></i></a>
                <mat-menu #heightMenu="matMenu">
                  <div class="tooltip-container slider-container" style="text-overflow: clip"
                    (click)="$event.stopPropagation()">
                    <span>Height</span>
                    <mat-slider [min]="200" [max]="800" step="40">
                      <input matSliderThumb [(ngModel)]="shotGraphHeight" (ngModelChange)="onHeightSliderChange()"
                        #ngSliderThumb="matSliderThumb" />
                    </mat-slider>
                    <div class="tooltip">{{ shotGraphHeight }}</div>
                  </div>
                  <div class="tooltip-container slider-container" style="
                      text-overflow: clip;
                      display: flex;
                      justify-content: space-between;
                    " (click)="$event.stopPropagation()">
                    <span>Shot Radius</span>
                    <mat-slider [min]="1" [max]="10" step="0.5">
                      <input matSliderThumb [(ngModel)]="shotGraphRadius" #ngSliderThumb="matSliderThumb" />
                    </mat-slider>
                    <div class="tooltip">{{ shotGraphRadius }}</div>
                  </div>
                  @if (currentJob && currentJob.modelGrid && !currentJob.modelGrid.is2d) {
                  <div mat-menu-item>
                    <mat-slide-toggle [(ngModel)]="preserveAspectRatio"
                      (change)="onPreserveAspectRatioChange($event.checked)" (click)="$event.stopPropagation()">
                      Preserve Aspect Ratio
                    </mat-slide-toggle>
                  </div>
                  }
                  <div mat-menu-item>
                    <mat-slide-toggle [(ngModel)]="smoothingEnabled"
                      (click)="$event.stopPropagation()"></mat-slide-toggle>
                    <span>Smoothing</span>
                  </div>
                  @if (!showSonicLog && currentJob.containsLog) {
                  <div mat-menu-item>
                    <mat-slide-toggle [(ngModel)]="showWellLog" (ngModelChange)="onShowWellLogs()"></mat-slide-toggle>
                    <span>Well Logs</span>
                  </div>
                  }
                  <button mat-menu-item [matMenuTriggerFor]="shotColourMenu">
                    Shot Colour
                  </button>
                  <mat-checkbox style="margin-left: 5%" [(ngModel)]="showNA">
                    Show 'N/A' Shots
                  </mat-checkbox>
                  <nz-input-group nzSize="large" class="legacy-input-styling">
                    <label>Shot Colour Min</label>
                    <input nz-input [(ngModel)]="shotColor.min" (click)="$event.stopPropagation()"
                      (change)="updateShotColorRef()" />
                  </nz-input-group>
                  <nz-input-group nzSize="large" class="legacy-input-styling">
                    <label>Shot Colour Max</label>
                    <input nz-input [(ngModel)]="shotColor.max" (click)="$event.stopPropagation()"
                      (change)="updateShotColorRef()" />
                  </nz-input-group>
                  <button mat-menu-item (click)="updateBgRange()">
                    Reset Vp Colour Scale
                  </button>
                  <nz-input-group nzSize="large" class="legacy-input-styling">
                    <label>Min</label>
                    <input nz-input [(ngModel)]="_minValZ" (click)="$event.stopPropagation()"
                      (keyup)="submitShotsGraphMinMax($event)" />
                  </nz-input-group>
                  <nz-input-group nzSize="large" class="legacy-input-styling">
                    <label>Max</label>
                    <input nz-input [(ngModel)]="_maxValZ" (click)="$event.stopPropagation()"
                      (keyup)="submitShotsGraphMinMax($event)" />
                  </nz-input-group>
                  <mat-checkbox style="margin-left: 5%" [checked]="plotRcvr" (change)="plotRcvr = !plotRcvr">Show
                    Receivers
                  </mat-checkbox>
                  <nz-input-group nzSize="large" class="legacy-input-styling">
                    <label>Receiver Sample Interval</label>
                    <input nz-input [(ngModel)]="rcvrInterval" (click)="$event.stopPropagation()"
                      (focusout)="updateDisplayingRcvr()" />
                  </nz-input-group>
                  <mat-checkbox style="margin-left: 5%;" [(ngModel)]="selectRcvrs" nz-tooltip
                    nzTooltipTitle="To toggle [Shift + B]">Select
                    Receivers
                  </mat-checkbox>
                    <div (click)="$event.stopPropagation()">
                      <span style="padding-left: 10px">Start (km)</span>
                      <div style="display: flex; margin-top:5px; gap: 5px">
                          <nz-input-group class="legacy-input-styling" style="flex: 1">
                              <label>X</label>
                              <nz-input-number style="width: 100%" [nzMin]="0" [nzMax]="modelMax.x" [ngModel]="rangesStart.x()" (change)="setValueOfSignal($event, rangesStart.x, 0)"></nz-input-number>
                          </nz-input-group>
                          <nz-input-group class="legacy-input-styling" style="flex: 1">
                              <label>Y</label>
                              <nz-input-number style="width: 100%" [nzMin]="0" [nzMax]="modelMax.y" [ngModel]="rangesStart.y()" (change)="setValueOfSignal($event, rangesStart.y, 0)"></nz-input-number>
                          </nz-input-group>
                      </div>
                    </div>
                    <div (click)="$event.stopPropagation()">
                      <span style="padding-left: 10px">End (km)</span>
                      <div style="display: flex; margin-top:5px; gap: 5px">
                          <nz-input-group class="legacy-input-styling" style="flex: 1">
                              <label>X</label>
                              <nz-input-number style="width: 100%" [nzMax]="modelMax.x" [ngModel]="rangesEnd.x()" (change)="setValueOfSignal($event, rangesEnd.x, modelMax.x)"></nz-input-number>
                          </nz-input-group>
                          <nz-input-group class="legacy-input-styling" style="flex: 1">
                              <label>Y</label>
                              <nz-input-number style="width: 100%" [nzMax]="modelMax.y" [ngModel]="rangesEnd.y()" (change)="setValueOfSignal($event, rangesEnd.y, modelMax.y)"></nz-input-number>
                          </nz-input-group>
                      </div>
                  </div>
                  <button mat-menu-item (click)="resetRange()">
                    Reset Ranges
                  </button>
                </mat-menu>
              </div>
              <mat-menu #shotColourMenu="matMenu">
                <ng-template matMenuContent>
                  @for (colourType of shotColourTypes; track colourType) {
                  <button mat-menu-item (click)="
                      selectedShotColourType = colourType.id;
                      $event.stopPropagation()
                    ">
                    <span>{{ colourType.name }}</span>
                    @if (selectedShotColourType === colourType.id) {
                    <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                    }
                  </button>
                  }
                </ng-template>
              </mat-menu>
              <div class="row" style="margin: 0px;">
                <div [style.width]="preserveAspectRatio ? shotGraphWidth : '100%'" style="margin: 0 auto; max-width: 100%">
                  <app-shots-graph #shots [showNA]="showNA" [height]="shotGraphHeight" [plotRcvrs]='plotRcvr'
                    [selectRcvrs]="selectRcvrs" [rcvrData]="rcvrDataDisplay" [shotData]="shotData" [wellLogs]="wellLogs"
                    [backgroundImage]="shotBgImg" [xCrop]="xCrop" [yCrop]="yCrop" [colorScale]="shotColor"
                    [selectedShot]="selectedShot" [colourType]="selectedShotColourType"
                    [(rcvrsBoundingBox)]="selectedRcvrsLimit" [radius]="shotGraphRadius"
                    (onShotSelected)="onShotSelected($event)" [shotType]="shotType"
                    (onRcvrsSelected)="onRcvrsSelected($event)" [isMainImage]="false"></app-shots-graph>
                </div>
              </div>
            </div>
          </div>
          }
          @if (shotData) {
          <div style="padding: 0px 20px" class="col-md-5 container-fluid control-panel">
            <div class="row" style="margin: 0px; padding: 0px">
              <div class="panel-info" style="
                  padding: 0px;
                  display: flex;
                  flex-wrap: wrap;
                  gap: 5px 30px;
                ">
                <div style="
                    flex: 1 1 100%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Iteration Frequency:</label>
                  <span style="text-align: right">{{
                    iterationFrequency ? iterationFrequency + " Hz" : "N/A"
                    }}</span>
                </div>
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Number of Traces:</label>
                  <span style="text-align: right">{{
                    numTraces || "N/A"
                    }}</span>
                </div>
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Total Time:</label>
                  <span style="text-align: right">{{
                    totalTime ? (totalTime | number : "1.0-3") + " s" : "N/A"
                    }}</span>
                </div>
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Number of Samples:</label>
                  <span style="text-align: right">{{
                    numSamples || "N/A"
                    }}</span>
                </div>
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Time Interval:</label>
                  <span style="text-align: right">{{
                    totalTime
                    ? ((totalTime * 1000) / numSamples | number : "1.0-3") +
                    " ms"
                    : "N/A"
                    }}
                  </span>
                </div>
                @if (isStaff) {
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Trace fit:</label>
                  @if (selectedTraceFit) {
                  <span style="text-align: right">{{ selectedTraceFit[0].toFixed(2) || "N/A" }}
                  </span>
                  }
                </div>
                }
                @if (isStaff) {
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Trace fit raw:</label>
                  @if (selectedTraceFit) {
                  <span style="text-align: right">{{ selectedTraceFit[1].toFixed(2) || "N/A" }}
                  </span>
                  }
                </div>
                }
                @if (isStaff) {
                <div style="
                    flex: 1 1 45%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Shot Id:</label>
                  <span style="text-align: right">{{ selectedShot }} </span>
                </div>
                }
                @if (isStaff) {
                <div style="
                    flex: 1 1 100%;
                    display: flex;
                    justify-content: space-between;
                  ">
                  <label style="font-weight: 600">Shot Colour Type:</label>
                  @if (selectedShotColourType) {
                  <span style="text-align: right">{{
                    selectedShotColourTypeName || "N/A" }}
                  </span>
                  }
                </div>
                }
              </div>
            </div>
            <div style="display: flex; gap: 30px; justify-content: center; flex-wrap: wrap">
              <nz-input-group style="width: 150px; padding: 0px" class="legacy-input-styling">
                <label for="startTrace" style="left: 10px">Start Trace</label>
                <input noScrollNumber nz-input name="startTrace" id="startTrace" type="number" placeholder="Start Trace"
                  [(ngModel)]="startTrace" (keyup)="onKeySubmission($event)" />
              </nz-input-group>
              <nz-input-group style="width: 150px; padding: 0px" class="legacy-input-styling">
                <label for="endTrace" style="left: 10px">End Trace</label>
                <input noScrollNumber nz-input id="endTrace" name="endTrace" type="number" placeholder="End Trace"
                  [(ngModel)]="endTrace" (keyup)="onKeySubmission($event)" />
              </nz-input-group>
            </div>
            <div style="display: flex; gap: 30px; justify-content: center; flex-wrap: wrap">
              <nz-input-group style="width: 150px; padding: 0px" class="legacy-input-styling">
                <label for="startTime" style="left: 10px">Start Time</label>
                <input noScrollNumber nz-input name="startTime" id="startTime" type="number" placeholder="Start Time"
                  [(ngModel)]="start_time" (keyup)="onKeySubmission($event)" (change)="checkStartTimeEndTime()" />
              </nz-input-group>
              <nz-input-group style="width: 150px; padding: 0px" class="legacy-input-styling">
                <label for="endTime" style="left: 10px">End Time</label>
                <input noScrollNumber nz-input id="endTime" name="endTime" type="number" placeholder="End Time"
                  [(ngModel)]="end_time" (keyup)="onKeySubmission($event)" (change)="checkStartTimeEndTime()" />
              </nz-input-group>
            </div>
            <div class="row submit" style="margin: 0px">
              <button mat-stroked-button color="primary" [disabled]="!selectedShot" class="col-md-4"
                (click)="onReplotClicked()">
                Replot
              </button>
            </div>
          </div>
          }
        </div>

        <mat-divider></mat-divider>
        @if (selectedShot) {
        <div class="row container-fluid" style="margin: 0" id="main-image">
          @if (
          shotType && shotType.name == 'custom_type' && shotType.options
          ) {
          <div class="col-md-12 shot-options">
            <mat-grid-list cols="3" rowHeight="40">
              @for (name of shotType.options; track name) {
              <mat-grid-tile class="res-type" [style.background]="name === customName ? 'lightgrey' : 'white'">
                <span style="width: 90%" (click)="onCustomNameSelected(name)">
                  {{ name }}
                </span>
              </mat-grid-tile>
              }
            </mat-grid-list>
          </div>
          }
          <div class="row shot-image-top" style="margin: 0">
            <div class="shot-image-tab-row" style="display: flex; justify-content: space-between">
              @if (panelNames != null) {
              <div [style]="
                  panelNames.length > 1
                    ? 'border-color: #ccc; border-style: solid; border-width: 0px 0px 1px 0px; padding: 0px;'
                    : 'border-width: 0px'
                " class="inner_tab col-md-8">
                @if (panelNames.length > 1) {
                  @if (isMobile) {
                    <button mat-stroked-button color="primary" [matMenuTriggerFor]="panelMenu">
                      <span>Panel: {{ tabNames[selectedPanel] }}</span>
                      <i class="zmdi zmdi-caret-down" style="display: inline-block"></i>
                    </button>
                  } @else {
                    <mat-tab-group [(selectedIndex)]="selectedPanel" (selectedIndexChange)="onTabSwitch()"
                      (keyup)="onKeySwitchTab($event)">
                      @for (name of tabNames; track name) {
                        <mat-tab [label]="name"></mat-tab>
                      }
                    </mat-tab-group>
                  }
                }
              </div>
              }
              <div class="image-height-trigger">
                <a [matMenuTriggerFor]="graphMenu"><i class="zmdi zmdi-hc-2x zmdi-more-vert"
                    style="width: 40px; text-align: center; margin-right: 7%"></i></a>
                <mat-menu class="matMenu" #graphMenu="matMenu">
                  <button mat-menu-item (click)="forceReplot()">
                    Force Replot
                  </button>
                  <div style="text-overflow: clip" class="tooltip-container slider-container">
                    Height
                    <mat-slider [min]="200" [max]="1000" step="50" (click)="$event.stopPropagation()" #ngSlider><input
                        matSliderThumb [(ngModel)]="mainGraphHeight"
                        (ngModelChange)="onMainHeightSliderChange()" /></mat-slider>
                    <div class="tooltip">{{ mainGraphHeight }}</div>
                  </div>
                  @if (shotType.name == 'RcvrList' && typeOfSelectedRcvr.name == 'RcvrList' && currentJob &&
                  currentJob.modelGrid && !currentJob.modelGrid.is2d) {
                  <mat-slide-toggle style="margin-left: 5%; width: 95%" [(ngModel)]="preserveRcvrAspectRatio"
                    (change)="onPreserveRcvrAspectRatioChange($event.checked)"
                    (click)="$event.stopPropagation()">Preserve Aspect Ratio</mat-slide-toggle>
                  }
                  @if (rcvrDistance != null && !this.isSpectrum) {
                  <mat-slide-toggle style="margin-left: 5%; width: 95%" [(ngModel)]="mute"
                    (change)="toggleMute()">Mute</mat-slide-toggle>
                  }
                  @if (!this.isSpectrum) {
                  <mat-slide-toggle style="margin-left: 5%; width: 95%" [(ngModel)]="enable_corr"
                    (change)="toggleCorr()">Correlation</mat-slide-toggle>
                  }
                  @if (shotType != null && shotType.fwd) {
                  <button mat-menu-item [matMenuTriggerFor]="shotTypeDetailMenu">
                    Shot Type Detail
                  </button>
                  }
                  @if (isSpectrum) {
                  <nz-input-group class="legacy-input-styling" (click)="$event.stopPropagation()">
                    <label> Y-Axis Min </label>
                    <nz-input-number style="width: 100%" nzPrecision="10" [(ngModel)]="spectrumRange[0]"
                      (keyup)="submitSpectrumRange($event)"></nz-input-number>
                  </nz-input-group>
                  }
                  @if (isSpectrum) {
                  <nz-input-group class="legacy-input-styling" (click)="$event.stopPropagation()">
                    <label> Y-Axis Max </label>
                    <nz-input-number nzPrecision="10" style="width: 100%" [(ngModel)]="spectrumRange[1]"
                      (keyup)="submitSpectrumRange($event)"></nz-input-number>
                  </nz-input-group>
                  }
                  @if (isSpectrum) {
                  <nz-input-group class="legacy-input-styling" (click)="$event.stopPropagation()">
                    <label> X-Axis Min </label>
                    <nz-input-number nzPrecision="10" style="width: 100%" [(ngModel)]="spectrumRangeX[0]"
                      (keyup)="submitSpectrumRange($event)"></nz-input-number>
                  </nz-input-group>
                  }
                  @if (isSpectrum) {
                  <nz-input-group class="legacy-input-styling" (click)="$event.stopPropagation()">
                    <label> X-Axis Max </label>
                    <nz-input-number nzPrecision="10" style="width: 100%" [(ngModel)]="spectrumRangeX[1]"
                      (keyup)="submitSpectrumRange($event)"></nz-input-number>
                  </nz-input-group>
                  }
                  @if (
                  shotType.name == 'RcvrList' &&
                  shotType.filterSettings.value == 'corr'
                  ) {
                  <nz-input-group class="legacy-input-styling" (click)="$event.stopPropagation()">
                    <label> Shot Colour Min </label>
                    <nz-input-number nzPrecision="10" style="width: 100%" [(ngModel)]="inputRcvrScale.min"
                      (keyup)="submitCorrRange($event)"></nz-input-number>
                  </nz-input-group>
                  }
                  @if (
                  shotType.name == 'RcvrList' &&
                  shotType.filterSettings.value == 'corr'
                  ) {
                  <nz-input-group class="legacy-input-styling" (click)="$event.stopPropagation()">
                    <label> Shot Colour Max </label>
                    <nz-input-number nzPrecision="10" style="width: 100%" [(ngModel)]="inputRcvrScale.max"
                      (keyup)="submitCorrRange($event)"></nz-input-number>
                  </nz-input-group>
                  }
                  @if (isSpectrum) {
                  <button mat-menu-item [matMenuTriggerFor]="spectrumMenu" class="spectrum-select">
                    Data
                  </button>
                  }
                  @if (isSpectrum) {
                  <button mat-menu-item [matMenuTriggerFor]="spectrumDatatTypeMenu">
                    Data Type
                  </button>
                  }
                  <mat-menu #spectrumDatatTypeMenu="matMenu">
                    <div mat-menu-item>
                      <mat-checkbox [(ngModel)]="spectrumDataType.field" (change)="onSpectrumDataChanged()">
                        Field
                      </mat-checkbox>
                    </div>
                    <div mat-menu-item>
                      <mat-checkbox [(ngModel)]="spectrumDataType.predicted" (change)="onSpectrumDataChanged()">
                        Predicted
                      </mat-checkbox>
                    </div>
                  </mat-menu>
                  @if (selectedPanel < 3 && shotType.name !='SelectRcvrs' ) { <div mat-menu-item
                    [matMenuTriggerFor]="palleteOptions">
                    Color Palette
              </div>
              }
              <div mat-menu-item (click)="screenshotPage()" [matMenuTriggerFor]="screenshotOptions">
                Screenshot
              </div>
              <mat-menu #spectrumMenu="matMenu">
                @for (iter of spectrumIterOptions; track iter; let i = $index) {
                <button mat-menu-item (click)="
                          $event.stopPropagation(); toggleSpectrumIter(i)
                        ">
                  <span> {{ iter }} </span>
                  @if (
                  spectrumOn != null &&
                  spectrumOn[iter] != null &&
                  spectrumOn[iter][0] != null &&
                  spectrumOn[iter][0]
                  ) {
                  <i class="zmdi zmdi-check" style="display: inline-block"></i>
                  }
                </button>
                }
              </mat-menu>
              </mat-menu>
              <mat-menu #palleteOptions="matMenu">
                <ng-template matMenuContent>
                  @for (p of ['RED_WHITE_BLUE', 'BLUE_WHITE_RED', 'BLACK_AND_WHITE', 'WHITE_AND_BLACK']; track p) {
                  <div mat-menu-item (click)="changePalette(p)">
                    {{p}}
                    @if (color_palette === p) {
                    <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                    }
                  </div>
                  }
                </ng-template>
              </mat-menu>
              <mat-menu #screenshotOptions="matMenu">
                <ng-template matMenuContent>
                  <div mat-menu-item (click)="$event.stopPropagation()">
                    <mat-slide-toggle [(ngModel)]="screenshotWithShotsInfo">
                      With shots information
                    </mat-slide-toggle>
                  </div>
                  @if (shotType.name=='SelectRcvrs') {
                  <div mat-menu-item (click)="$event.stopPropagation()">
                    <mat-slide-toggle [(ngModel)]="screenshotWithSpatialPlotInfo">
                      With spatial plotting parameters
                    </mat-slide-toggle>
                  </div>
                  }
                </ng-template>
              </mat-menu>
              <mat-menu #panelMenu="matMenu">
                <ng-template matMenuContent>
                  @for (name of tabNames; track name; let i = $index) {
                  <button mat-menu-item (click)="selectedPanel = i; onTabSwitch()">
                    {{ name }}
                    @if (selectedPanel === i) {
                    <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                    }
                  </button>
                  }
                </ng-template>
              </mat-menu>
              <mat-menu #shotTypeMenu="matMenu" class="long-menu">
                <ng-template matMenuContent>
                  @for (column of tableTypes; track column) {
                  @for (fileType of column; track fileType) {
                  <button mat-menu-item (click)="onShotTypeChange(fileType, $event)">
                    {{ fileType.displayName }}
                    @if (fileType === shotType) {
                    <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                    }
                  </button>
                  }
                  }
                </ng-template>
              </mat-menu>
              <mat-menu #shotTypeDetailMenu="matMenu">
                <ng-template matMenuContent>
                  @for (typeDetail of typeDetails; track typeDetail) {
                  <button mat-menu-item (click)="onShotTypeDetailChange(typeDetail.value, $event)">
                    <span>{{ typeDetail.name }}</span>
                    @if (typeDetail.value === shotType.fwd) {
                    <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                    }
                  </button>
                  }
                </ng-template>
              </mat-menu>
            </div>
          </div>
          <div class="iter-switch row" style="margin: 0">
            <div class="function-buttons">
              <button mat-stroked-button color="primary" [matMenuTriggerFor]="shotMenu">
                <span>Shot: {{ selectedShot }}</span>
                <i class="zmdi zmdi-caret-down" style="display: inline-block"></i>
              </button>
              <mat-menu #shotMenu="matMenu">
                <ng-template matMenuContent>
                  @for (shot of shotsWithTraces; track shot) {
                  <button mat-menu-item (click)="onShotSelected(shot.shotId)">
                    {{ shot.shotId }}
                  </button>
                  }
                </ng-template>
              </mat-menu>
              <div style="display: contents">
                @if (!isSpectrum) {
                <button mat-stroked-button color="primary" [matMenuTriggerFor]="iterMenu">
                  <span>Iteration: {{ iteration }}</span>
                  <i class="zmdi zmdi-caret-down" style="display: inline-block"></i>
                </button>
                }
                @if (isSpectrum) {
                <button mat-stroked-button color="primary" [matMenuTriggerFor]="spectrumIterMenu">
                  <span>Iteration: {{ iteration }}</span>
                  <i class="zmdi zmdi-caret-down" style="display: inline-block"></i>
                </button>
                }
                @if (shotType.name != 'SelectRcvrs') {
                <button mat-stroked-button color="primary" style="text-overflow:clip; cursor: pointer;"
                  (click)="openScalingModal()">
                  Scaling
                </button>
                }
                <button mat-stroked-button color="primary" [matMenuTriggerFor]="shotTypeMenu">
                  <span>Shot Type: {{shotType.displayName}}</span>
                  <i class="zmdi zmdi-caret-down" style="display: inline-block"></i>
                </button>
              </div>
              @if (shotType.name == 'Source') {
              <nz-input-group class="legacy-input-styling" style="width: 150px; margin-left: 10px; padding: 0;">
                <label style="left: 10px">Max Frequency</label>
                <input nz-input type="number" placeholder="Frequency Limit" [(ngModel)]="frequencyLimit"
                  (keyup)="onFrequencyLimitChange($event)" />
              </nz-input-group>
              }
              <mat-menu #iterMenu="matMenu">
                <ng-template matMenuContent>
                  @for (iter of itersOfSameShot; track iter) {
                  <button mat-menu-item (click)="onIterationSwitch(iter)">
                    {{ iter }}
                  </button>
                  }
                </ng-template>
              </mat-menu>
              <mat-menu #spectrumIterMenu="matMenu">
                <ng-template matMenuContent>
                  @for (iter of spectrumIterOptions; track iter) {
                  <button mat-menu-item (click)="onIterationSwitch(iter)">
                    {{ iter }}
                  </button>
                  }
                </ng-template>
              </mat-menu>
              @if (switchIteration) {
              <button mat-stroked-button color="primary" (click)="onIterationSwitch()">
                <span>Back to iteration {{ switchIteration }}</span>
              </button>
              }
              @if (shotType.name != 'Source') {
              <div class="color-div" style="margin-left: 10px; margin-top: 10px">
                @if (!isPhaseDiff && !isSpectrum) {
                <div>
                  @if (
                  shotType.name == 'RcvrList' &&
                  !!rcvrScale &&
                  typeOfSelectedRcvr.name == 'RcvrList'
                  ) {
                  <div class="colorbar">
                    <span>{{ shotType.displayName }}</span>
                    @if (shotType.filterSettings.value != 'corr') {
                    <div class="color-bar-bwr"></div>
                    }
                    @if (shotType.filterSettings.value == 'corr') {
                    <div class="color-bar-gray"></div>
                    }
                    <div class="color-bar-stat" style="display: flex; justify-content: space-between">
                      <span>{{ rcvrScale.min.toExponential(3) }}</span>
                      <span style="float: right">{{
                        rcvrScale.max.toExponential(3)
                        }}</span>
                    </div>
                  </div>
                  }
                  @if (
                  (shotType.name != 'RcvrList' ||
                  typeOfSelectedRcvr.name != 'RcvrList') &&
                  !!clipValue
                  ) {
                  <div class="colorbar">
                    <span>{{ shotType.displayName }}</span>
                    @if (color_palette == 'RED_WHITE_BLUE') {
                    <div class="color-bar-bwr"></div>
                    }
                    @if (color_palette == 'BLUE_WHITE_RED') {
                    <div class="color-bar-bwr-r"></div>
                    }
                    @if (color_palette == 'BLACK_AND_WHITE') {
                    <div class="color-bar-gray-r"></div>
                    }
                    @if (color_palette == 'WHITE_AND_BLACK') {
                    <div class="color-bar-gray-r"></div>
                    }
                    @if (!isInterleaveType) {
                    <div class="color-bar-stat" style="display: flex; justify-content: space-between">
                      @if (clipValue[0] != null) {
                      <span>{{
                        clipValue[0].toExponential(3)
                        }}</span>
                      }
                      @if (clipValue[1] != null) {
                      <span style="float: right">{{ clipValue[1].toExponential(3)
                        }}</span>
                      }
                    </div>
                    }
                    @if (isInterleaveType) {
                    <div class="color-bar-stat" style="position: relative; height: 22px;"
                      [style.fontSize]="fieldScaling[0] == predictedScaling[0] && fieldScaling[1] == predictedScaling[1] ? '14px' : '10px'">
                      @if (fieldScaling[0] == predictedScaling[0] && fieldScaling[1] == predictedScaling[1]) {
                      <div style="display: flex; justify-content: space-between; width: 100%">
                        @if (predictedScaling[0] != null) {
                        <span>{{
                          predictedScaling[0].toExponential(3)
                          }}</span>
                        }
                        @if (predictedScaling[1] != null) {
                        <span style="float: right">{{
                          predictedScaling[1].toExponential(3)
                          }}</span>
                        }
                      </div>
                      } @else {
                      <div style="display: flex; justify-content: space-between; position: absolute; width: 100%">
                        @if (predictedScaling[0] != null) {
                        <span>{{
                          predictedScaling[0].toExponential(3)
                          }}</span>
                        }
                        <span>P</span>
                        @if (predictedScaling[1] != null) {
                        <span style="float: right">{{
                          predictedScaling[1].toExponential(3)
                          }}</span>
                        }
                      </div>
                      <div
                        style="display: flex; justify-content: space-between; position: absolute; top: 10px; width: 100%">
                        @if (fieldScaling[0] != null) {
                        <span>{{
                          fieldScaling[0].toExponential(3)
                          }}</span>
                        }
                        <span>D</span>
                        @if (fieldScaling[1] != null) {
                        <span style="float: right">{{
                          fieldScaling[1].toExponential(3)
                          }}</span>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
                }
                @if (isPhaseDiff) {
                <div class="phasediff-colorbar">
                  <div style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                      ">
                    <img src="../../../../assets/colorbar/phasediff_colorbar.png" style="width: 100%; height: 20px" />
                  </div>
                  <div style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      ">
                    <span>-pi</span>
                    <span>pi</span>
                  </div>
                </div>
                }
                @if (isSpectrum) {
                <div style="height: 64px"></div>
                }
              </div>
              }
            </div>
          </div>
        </div>
        <div class="image-div" (keyup)="onKeySwitchGraph($event)" tabindex="0" id="imageDiv">
          @if (!shotType.independent) {
          @if (loadingImage) {
          <div class="loading">
            <mat-progress-spinner mode="indeterminate" class="spinner" diameter="30"></mat-progress-spinner>
            <span class="loading-text">loading image</span>
          </div>
          }
          @if (imageUrl || rcvrData) {
          <div class="row" style="margin: 0">
            @if (
            shotType.name == 'RcvrList' &&
            typeOfSelectedRcvr.name == 'RcvrList'
            ) {
            <div>
              <div #rcvrGraphWrapper
                [style.width]="preserveRcvrAspectRatio ? rcvrGraphWidth : defaultRcvrGraphWidth"
                style="margin-left: auto; margin-right: auto; max-width: 100%">
                <app-shots-graph #rcvrGraph (onShotSelected)="onRcvrSelected($event)" [height]="mainGraphHeight"
                  [shotData]="rcvrData" [backgroundImage]="shotBgImg" [xCrop]="xCrop" [yCrop]="yCrop"
                  [selectedShot]="null" [colourType]="selectedShotColourType" [colorScale]="rcvrScale"
                  [colorMap]="rcvrColorMap" [isMainImage]="true"></app-shots-graph>
              </div>
            </div>
            }
            @if (
            shotType.name != 'RcvrList' ||
            typeOfSelectedRcvr.name != 'RcvrList'
            ) {
            <div>
              <div class="image-switch-wrapper col-md-1">
                @if (hasLeftPage && imageUrl) {
                <div [ngStyle]="{
                      height: mainGraphHeight * 0.9 + 'px',
                      float: 'right'
                    }" class="image-switch" (click)="onSliceChange(false)">
                  <div class="image-switch-middle">
                    <i style="margin-right: 10%; float: right" class="zmdi zmdi-hc-2x zmdi-caret-left"></i>
                  </div>
                </div>
                }
              </div>
              @if (imageUrl) {
              <app-d3-image id="shot-image" class="image col-md-10 col-12" [ngClass]="{
                    'left-shadow': hasLeftPage && !isMobile,
                    'right-shadow': hasRightPage && !isMobile,
                    'shadow-both': hasLeftPage && hasRightPage && !isMobile
                  }" [height]="mainGraphHeight" [hideAxes]="shotType && shotType.hideAxes"
                [smoothingEnabled]="smoothingEnabled" 
                [image]="{
                    backgroundImage: imageUrl,
                    totalTime: totalTime,
                    range: { startTrace: startTrace, endTrace: endTrace },
                    rcvrDistances: rcvrDistances,
                    distanceTypes: muteDistanceTypes,
                    interleaveInfo: {
                      isInter: isInterleaveType,
                      extent: interleave_extent
                    },
                    slope: muteSlope,
                    intersection: muteIntersection,
                    muteOn: muteOn,
                    colors: colors,
                    offsets: muteOffset,
                    mute: mute,
                    corr_start_time: corr_start_time,
                    corr_end_time: corr_end_time,
                    axis_start_time: start_time,
                    axis_end_time: end_time,
                    enable_window: enable_corr,
                    panel_name: panelNames[selectedPanel],
                    spectrum: spectrum,
                    spectrumOn: spectrumOn,
                    spectrumColors: spectrumColors,
                    spectrumRange: spectrumRange,
                    spectrumRangeX: spectrumRangeX,
                    spectrumIterOptions: spectrumIterOptions,
                    spectrumDataType: spectrumDataType
                  }" (time_window_emitter)="onTimeWindowEmit($event)" (width_emitter)="onWidthEmit($event)"
                (spectrum_range_emitter)="onSpectrumRangeEmit($event)"
                (spectrum_range_x_emitter)="onSpectrumRangeXEmit($event)">
              </app-d3-image>
              }
              @if (
              imageUrl == null &&
              this.loadingImage == false &&
              !this.isSpectrum
              ) {
              <div class="image col-md-10" style="
                    display: flex;
                    align-items: center;
                    height: 500px;
                    justify-content: center;
                  ">
                <div style="text-align: center">DUMPS NOT AVAILABLE</div>
              </div>
              }
              <div class="col-md-1 image-switch-wrapper">
                @if (hasRightPage && imageUrl) {
                <div [ngStyle]="{ height: mainGraphHeight * 0.9 + 'px' }" class="image-switch"
                  (click)="onSliceChange(true)">
                  <div class="image-switch-middle">
                    <i style="margin-left: 10%" class="zmdi zmdi-hc-2x zmdi-caret-right"></i>
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </div>
          }
          <div class="row" style="margin: 10px 0px 0px 0px">
            @if (
            shotType &&
            shotType.name != 'custom_type' &&
            shotType.options &&
            shotType.options.length > 0
            ) {
            <div class="col-md-12 shot-options" style="padding: 0px">
              <div style="display: flex; flex-wrap: wrap; gap: 10px">
                @for (option of shotType.options; track option) {
                <div style="flex: 1 1 150px; margin: 0px" class="shot-option">
                  @if (option.values) {
                  <div>
                    <label style="margin: 0">{{
                      option.displayName
                      }}</label>
                    <nz-radio-group [(ngModel)]="shotType.filterSettings[option.name]">
                      @for (value of option.values; track value) {
                      <label nz-radio class="radio-button" [nzValue]="value" [checked]="
                              shotType.filterSettings[option.name] == value
                            ">{{ value }}</label>
                      }
                    </nz-radio-group>
                  </div>
                  }
                  @if (!option.values) {
                  <nz-input-group class="legacy-input-styling" style="flex-grow: 1; margin: 0px; padding: 0px">
                    <label style="left: 10px">{{ option.displayName }}</label>
                    <input nz-input [type]="option.type || 'number'" [placeholder]="option.displayName"
                      [(ngModel)]="shotType.filterSettings[option.name]" />
                  </nz-input-group>
                  }
                </div>
                }
              </div>
              <section style="display: flex; justify-content: flex-end">
                <button mat-stroked-button color="primary" [disabled]="!selectedShot" class="shot-option"
                  (click)="onReplotClicked()">
                  Replot
                </button>
                <button mat-stroked-button color="primary" [matMenuTriggerFor]="subTypeMenu">
                  <span>Type: {{ typeOfSelectedRcvr.displayName }}</span>
                  <i class="zmdi zmdi-caret-down" style="display: inline-block"></i>
                </button>
                <mat-menu #subTypeMenu="matMenu">
                  <ng-template matMenuContent>
                    @for (type of types; track type) {
                    <button mat-menu-item (click)="changeRcvrPlotType(type)">
                      {{ type.displayName }}
                      @if (type == typeOfSelectedRcvr) {
                      <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                      }
                    </button>
                    }
                  </ng-template>
                </mat-menu>
              </section>
            </div>
            }
            @if (shotType && shotType.name == 'custom') {
            <div class="col-md-12 shot-options">
              <div class="shot-option">
                <mat-form-field>
                  <input matInput placeholder="Filter Name" [(ngModel)]="customShotName" />
                </mat-form-field>
              </div>
              <div class="shot-option">
                <mat-form-field>
                  <input matInput placeholder="Settings" [(ngModel)]="customShotSettings" />
                </mat-form-field>
              </div>
              <button mat-stroked-button color="primary" [disabled]="!selectedShot" class="shot-option"
                style="width: 60px" (click)="onReplotClicked()">
                Replot
              </button>
            </div>
            }
          </div>
          @if (
          !imageUrl && !loadingImage && !rcvrData && !is_updating_graph
          ) {
          <div class="error-message">
            @if (!shotImageError) {
            <h3>No trace file for this iteration</h3>
            }
            @if (shotImageError) {
            <h3>
              {{ shotImageError }}
            </h3>
            }
          </div>
          }
          }
          @if (shotType.name == 'SelectRcvrs' && shotData && rcvrDataFull) {
          <ng-container #SpatialPlottingV2>
            <app-spatial-plotting-v2 #spatialPlottingV2Component [totalTime]="totalTime"
              [panel]="this.panelNames[this.selectedPanel]" [height]="mainGraphHeight"
              [(filterSettings)]="shotType.filterSettings" (filterSettingsChange)="updateUrl()"
              [(rcvrsBoundingBox)]="selectedRcvrsLimit" (updateColorbarLimits)="updateColorbarLimits($event)"
              [rcvrData]="rcvrDataFull" [selectedShotId]="selectedShot" [shotData]="shotData" [iteration]="iteration"
              [endTime]="end_time" [startTime]="start_time" [muteSlope]="muteSlope"
              [muteIntersection]="muteIntersection" [muteOffset]="muteOffset" [muteDistanceTypes]="muteDistanceTypes" [muteOn]="muteOn" [mute]="mute">
            </app-spatial-plotting-v2>
          </ng-container>
          }
          @if (shotType.name == 'Source' && shotData) {
          <div style="flex: 1; padding: 2rem;">
            <app-source-plotting #sourcePlotting [height]="mainGraphHeight" [shotsData]="shotData"
              [activeShotId]="selectedShot" [iteration]="iteration" [endTime]="end_time" [startTime]="start_time">
            </app-source-plotting>
          </div>
          }
        </div>
        @if (corr!=null && enable_corr && corr.length > 0 && shotType.name != 'RcvrList') {
        <div style="display: flex; width: 100%; margin: 0" class="row">
          <div class="image-switch-wrapper" style="width:8.34%; padding: 0 15px;"></div>
          <nz-spin [nzSpinning]="loadingCorr">
            <div class="corr-bar" [ngStyle]="gradientStyle" [style.width]="shotImageWidth.toString() + 'px'"
              [style.margin-left]="this.isMobile ? '30px' : '32px'"
              [style.margin-right]="this.isMobile ? '10px' : '12px'"></div>
          </nz-spin>
          <div class="image-switch-wrapper" style="width: 8.34%; padding: 0 15px"></div>
        </div>
        }
        <div id="shot-image-bottom" class="shot-image-bottom" style="margin: 0; position: relative">
          @if (
          !isMobile &&
          enable_corr &&
          corr.length > 0 &&
          shotType.name != 'RcvrList'
          ) {
          <div class="corr-color-div" [ngStyle]="corrColorStyle" style="margin-left: 15px; margin-right: 15px">
            <div style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 10px;
                ">
              <span style="margin-top: 10px">-1</span>
              <span style="margin-top: 10px">Correlation</span>
              <span style="margin-top: 10px">1</span>
            </div>
            <div style="display: flex; justify-content: space-between">
              <span>Mean: {{ corr_mean.toPrecision(3) }}</span>
              <span>Std: {{ corr_std.toPrecision(3) }}</span>
            </div>
            <div style="position: absolute; right: 90px; top: 0px;">
              <b>Windowed Trace Fit: </b> {{correlation_mean_value}}
            </div>
          </div>
          }
          @if (isInterleaveType) {
          <nz-input-group class="legacy-input-styling interleave col-md-4" style="width: 200px; padding-left: 10px">
            <label>Interleave extent</label>
            <input nz-input type="number" noScrollNumber placeholder="Interleave extent" [(ngModel)]="interleave_extent"
              (keyup)="onKeySubmission($event)" />
          </nz-input-group>
          }
          @if (shotType.name == 'RcvrList') {
          <div class="col-md-5 row">
            <div class="col-md-4" style="margin-top: 2%">
              <span>Value: {{ rcvrValue.toExponential(2) }}</span>
            </div>
            <div class="col-md-4" style="margin-top: 2%">
              <span>Mean: {{ rcvrAvg.toExponential(2) }}</span>
            </div>
            <div class="col-md-4" style="margin-top: 2%">
              <span>Std: {{ rcvrStd.toExponential(2) }}</span>
            </div>
          </div>
          }
          <div class="download">
            @if (imageUrl != null && !isSpectrum) {
            <div>
              <a class="shot-height-trigger" [matMenuTriggerFor]="pngMenu"><i class="zmdi zmdi-download"
                  style="font-size: large"></i></a>
            </div>
            }
            <mat-menu #pngMenu="matMenu">
              <ng-template matMenuContent>
                <nz-input-group class="legacy-input-styling" style="width: 200px">
                  <label>Specify PNG Width:</label>
                  <input nz-input type="number" noScrollNumber [(ngModel)]="pngWidth"
                    (click)="$event.stopPropagation()" />
                </nz-input-group>
                <nz-input-group class="legacy-input-styling" style="width: 200px">
                  <label>Specify PNG Height:</label>
                  <input nz-input type="number" noScrollNumber [(ngModel)]="pngHeight"
                    (click)="$event.stopPropagation()" />
                </nz-input-group>
                <button nz-button nzType="primary" (click)="downloadPng()" style="margin-left: 10px">
                  <span nz-icon nzType="download"></span>
                  Download
                </button>
              </ng-template>
            </mat-menu>
          </div>
        </div>
        @if (
        isMobile &&
        enable_corr &&
        corr.length > 0 &&
        shotType.name != 'RcvrList'
        ) {
        <div style="display: flex; margin-bottom: 15px">
          <div class="corr-color-div" [ngStyle]="corrColorStyle" style="margin-right: 10%; margin-left: 7%">
            <div style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 10px;
                ">
              <span style="margin-top: 20px">-1</span>
              <span style="margin-top: 20px">Correlation</span>
              <span style="margin-top: 20px">1</span>
            </div>
          </div>
          <div style="justify-content: space-between">
            <span>Mean: {{ corr_mean.toPrecision(3) }}</span>
            <span>Std: {{ corr_std.toPrecision(3) }}</span>
          </div>
        </div>
        }
      </div>
      }
  </div>

  @if (mute) {
  <div class="row mute-controls">
    @for (name of muteName; track name; let i = $index) {
    <div class="mute-control">
      <div style="display: flex; flex-direction: column">
        <div style="display: inline">
          <div style="display: inline-block">{{ name }}</div>
          <div style="display: inline-block" class="circle" [style.background-color]="colors[i]"></div>
        </div>
        <mat-form-field style="margin-top: 5px">
          <mat-label>Growth</mat-label>
          <input matInput type="number" noScrollNumber [(ngModel)]="muteSlope[i]" (change)="updateRef()" />
        </mat-form-field>
        <mat-form-field>
          @if (name != 'rwi mute') {
          <mat-label>Start Time</mat-label>
          }
          @if (name == 'rwi mute') {
          <mat-label>Offset Cut</mat-label>
          }
          <input matInput type="number" noScrollNumber [(ngModel)]="muteIntersection[i]" (change)="updateRef()" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>At Offset</mat-label>
          <input matInput type="number" noScrollNumber [(ngModel)]="muteOffset[i]" (change)="updateRef()" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Distance Type</mat-label>
          <mat-select [(ngModel)]="muteDistanceTypes[i]" (ngModelChange)="muteDistanceTypeChanged()">
            @for (type of distanceTypes; track type) {
            <mat-option [(value)]="type.value">{{ type.name }}</mat-option>
            }
            <!-- <mat-option value="0">3D</mat-option>
                    <mat-option value="1">2D-nx1,nx2</mat-option>
                    <mat-option value="2">2D-nx1,nx3</mat-option>
                    <mat-option value="3">2D-nx2,nx3</mat-option> -->
          </mat-select>
        </mat-form-field>
        <div style="display: inline">
          <mat-slide-toggle style="display: inline-block" [(ngModel)]="muteOn[i]"
            (change)="updateRef()"></mat-slide-toggle>
          <mat-label style="display: inline-block; margin-left: 5%">Show</mat-label>
        </div>
      </div>
    </div>
    }
  </div>
  }
  <mat-divider></mat-divider>

  <div class="container-fluid data-block" style="margin: 0">
    <div style="display: flex;">
      <nz-input-group class="legacy-input-styling" style="padding: 0px; width: auto">
        <label style="left: 10px">Block Number</label>
        <nz-select [(ngModel)]="selectedBlk" style="width: 200px">
          @for (blk of blk_info; track blk; let number = $index) {
          <nz-option [nzValue]="blk" [nzLabel]="number + 1">
          </nz-option>
          }
        </nz-select>
      </nz-input-group>
      <div style="display: flex; justify-content: start; flex-wrap: wrap; flex-grow: 1">
        <div style="width: 150px; flex-grow: 1;">
          <b style="display: block; flex-grow: 1;">Frequency:</b>
          @if (selectedBlk) {
          <span>{{ blkParamValues.freq }}</span>
          }
        </div>
        <div style="width: 150px; flex-grow: 1;">
          <b style="display: block; flex-grow: 1;">Amplitude:</b>
          @if (selectedBlk) {
          <span>{{ blkParamValues.amplitude }}</span>
          }
        </div>
        <div style="width: 150px; flex-grow: 1;">
          <b style="display: block; flex-grow: 1;">AGC:</b>
          @if (selectedBlk) {
          <span>{{ blkParamValues.agc }}</span>
          }
        </div>
        <div style="width: 150px; flex-grow: 1;">
          <b style="display: block; flex-grow: 1;">Normalize:</b>
          @if (selectedBlk) {
          <span>{{ blkParamValues.normalize }}</span>
          }
        </div>
        <div style="width: 150px; flex-grow: 1;">
          <b style="display: block; flex-grow: 1;">df(x) Count:</b>
          @if (selectedBlk) {
          <span>{{ selectedShotLowcut }}</span>
          }
        </div>
      </div>

    </div>
  </div>
  </mat-card>
</div>

@if (!isMobile){  
  <div class="sliders-bar" [ngClass]="{ open: sliderBarOpen, visible: sliderBarVisible }"
    [style.bottom.px]="settingsBottomOffset">
    <div style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 20px;
        ">
      <h4 class="card-title" style="margin: 0.5em 10px">Settings</h4>
      <div class="actions" style="margin: 0px" (click)="sliderBarOpen = !sliderBarOpen">
        <i class="fa fa-arrow-up"></i>
      </div>
    </div>
    <div class="col-md-6" style="padding: 0">
      <div class="form-group">
        <!-- <label class="col-sm-2">Depth</label> -->
        <app-slider [antd]="true" label="Depth" class="col-sm-10" [min]="1" [max]="nx3" [step]="1" [(value)]="sliceNum"
          (valueChange)="onDepthChange()"></app-slider>
      </div>
    </div>
    <div class="col-md-6" style="padding: 0">
      <div class="form-group iteration-slider">
        <!-- <label class="col-sm-2">Iteration</label> -->
        <app-slider [antd]="true" label="Iteration" class="col-sm-10" [min]="1" [max]="totalIteration"
          [(value)]="iteration" [step]="1" (valueChange)="onIterationChange()"></app-slider>
      </div>
    </div>
    <div class="col-md-12" style="padding-right: 20px">
      <mat-checkbox style="float: right" [(ngModel)]="synchroniseSettings"
        (ngModelChange)="onSynchroniseChange($event)">Synchronise Settings</mat-checkbox>
    </div>
  </div>
}
<span class="foot-note"> * : parameter not specified in runfile </span>
</div>

<nz-modal [nzMaskClosable]="false" [nzVisible]="showClippingModal" nzTitle="Set Scaling"
  (nzOnCancel)="showClippingModal = false" (nzOnOk)="getShotImage()" (keyup)="onScalingModalKeyup($event)">
  <ng-container *nzModalContent>
    <div style="display: flex; justify-self: space-between;">
      <nz-input-group style="display: flex; align-items: center; gap: 10px;">
        <label>Auto</label>
        <nz-switch [(ngModel)]="velocityAuto" (ngModelChange)="onVelocityToggled()"></nz-switch>
      </nz-input-group>
      <nz-input-group style="display: flex; align-items: center; gap: 10px;">
        <label>Global Scaling</label>
        <nz-switch [(ngModel)]="globalScaling" (ngModelChange)="toggleGlobalScaling()"></nz-switch>
      </nz-input-group>
    </div>

    <nz-divider></nz-divider>

    @if (!isPhaseDiff) {
    @if (['Prediction', 'Field', 'Interleaved'].includes(panelNames[selectedPanel])) {
    <nz-radio-group [(ngModel)]="velocityAuto" (ngModelChange)="onVelocityToggled($event)" nzName="radiogroup"
      style="width: 100%;">
      <div>
        <label nz-radio [nzValue]="false">Clip (Value)</label>
        <div style="display: flex; justify-content: space-between; align-items: center; position: relative; gap: 10px">
          <nz-input-group class="legacy-input-styling" style="padding: 0; flex-grow: 1; position: relative;">
            <label style="left: 10px;">
              Clip Value (Predicted)
            </label>
            <nz-input-number [nzMin]="0" style="width: 100%;" [(ngModel)]="this.predictedScaling[1]"
              (ngModelChange)="onChangePredictedScaling()" (keyup)="onScalingModalKeyup($event)"
              [nzDisabled]="velocityAuto == true"></nz-input-number>
            @if (velocityAuto) {
            <div style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  " (click)="onScalingInputClickInModal()"></div>
            }
          </nz-input-group>
          <button nz-button [nzType]="globalScaling ? 'primary' : 'dashed'" style="width: 20px;"
            (click)="this.globalScaling = !this.globalScaling; toggleGlobalScaling()">
            <span nz-icon nzType="link" nzTheme="outline"></span>
            @if (!globalScaling) {
            <span nz-icon nzType="minus" nzTheme="outline" style="rotate: 45deg;
                  position: absolute;
                  left: 0px;
                  padding: 0px;
                  margin: 0px;
                  top: 7px;"></span>
            }
          </button>
          <nz-input-group class="legacy-input-styling" style="padding: 0; flex-grow: 1; position: relative;">
            <label style="left: 10px;">
              Clip Value (Field)
            </label>
            <nz-input-number [nzMin]="0" style="width: 100%;" [(ngModel)]="fieldScaling[1]"
              (ngModelChange)="fieldScaling[0] = -fieldScaling[1] || null; this.panelToScaling['Field'] = fieldScaling"
              (keyup)="onScalingModalKeyup($event)"
              [nzDisabled]="velocityAuto == true || globalScaling == true"></nz-input-number>
            @if (velocityAuto || globalScaling) {
            <div style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  " (click)="onScalingInputClickInModal()"></div>
            }
          </nz-input-group>
        </div>
      </div>
      <nz-divider></nz-divider>
      <div>
        <label nz-radio [nzValue]="true">Clip (Relative)</label>
        <div style="display: flex; justify-content: space-between; align-items: center; gap: 10px">
          <nz-input-group class="legacy-input-styling" style="padding: 0;">
            <label style="left: 10px;">Clipping (Predicted)</label>
            <nz-slider [nzDisabled]="velocityAuto == false" [(ngModel)]="predictedClipping"
              (ngModelChange)="onChangePredictedClipping()" [nzMin]="-2" [nzMax]="0" [nzStep]="0.2"></nz-slider>
          </nz-input-group>
          <button nz-button [nzType]="globalScaling ? 'primary' : 'dashed'" style="width: 20px;"
            (click)="this.globalScaling = !this.globalScaling; toggleGlobalScaling()">
            <span nz-icon nzType="link" nzTheme="outline"></span>
            @if (!globalScaling) {
            <span nz-icon nzType="minus" nzTheme="outline" style="rotate: 45deg;
                  position: absolute;
                  left: 0px;
                  padding: 0px;
                  margin: 0px;
                  top: 7px;"></span>
            }
          </button>
          <nz-input-group class="legacy-input-styling" style="padding: 0;">
            <label style="left: 10px;">Clipping (field)</label>
            <nz-slider [nzMin]="-2" [nzMax]="0" [nzStep]="0.2"
              [nzDisabled]="velocityAuto == false || globalScaling == true" [(ngModel)]="fieldClipping"></nz-slider>
          </nz-input-group>
        </div>
      </div>
    </nz-radio-group>
    } @else {
    <nz-radio-group [(ngModel)]="velocityAuto" (ngModelChange)="onVelocityToggled($event)" nzName="radiogroup"
      style="width: 100%;">
      <div>
        <label nz-radio [nzValue]="false">Clip (Value)</label>
        <nz-input-group class="legacy-input-styling" style="position: relative;">
          <label style="left: 10px;">
            Clip Value
          </label>
          <nz-input-number [nzMin]="0" style="width: 100%;" [(ngModel)]="currentScaling[1]"
            (ngModelChange)="currentScaling[0] = -currentScaling[1]" (keyup)="onScalingModalKeyup($event)"
            [nzDisabled]="velocityAuto == true"></nz-input-number>
          @if (velocityAuto) {
          <div style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                " (click)="onScalingInputClickInModal()"></div>
          }
        </nz-input-group>
      </div>
      <nz-divider></nz-divider>
      <div>
        <label nz-radio [nzValue]="true">Clip (Relative)</label>
        <nz-input-group class="legacy-input-styling" style="padding: 0;">
          <label style="left: 10px;">Clipping</label>
          <nz-slider [nzDisabled]="velocityAuto == false" [(ngModel)]="currentClipping" [nzMin]="-2" [nzMax]="0"
            [nzStep]="0.2"></nz-slider>
        </nz-input-group>
      </div>
    </nz-radio-group>
    }
    <nz-divider> </nz-divider>
    Color Palette
    <nz-radio-group [(ngModel)]="color_palette" (ngModelChange)="setClipping()">
      @for (p of ['RED_WHITE_BLUE', 'BLUE_WHITE_RED', 'BLACK_AND_WHITE', 'WHITE_AND_BLACK']; track p) {
      <label nz-radio-button [nzValue]="p">{{p}}</label>
      }
    </nz-radio-group>
    }

    @if (isPhaseDiff) {
    <nz-radio-group [(ngModel)]="velocityAuto" (ngModelChange)="onVelocityToggled($event)" nzName="radiogroup"
      style="width: 100%;">
      <div>
        <label nz-radio [nzValue]="false">Clip (Value)</label>
        <nz-input-group class="legacy-input-styling" style="padding: 0; flex-grow: 1; position: relative;">
          <label style="left: 10px;">
            Clip Value
          </label>
          <nz-input-number [nzMin]="0" style="width: 100%;" [(ngModel)]="currentScaling[1]"
            (keyup)="onScalingModalKeyup($event)" [nzDisabled]="velocityAuto == true"></nz-input-number>
          @if (velocityAuto) {
          <div style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
              " (click)="onScalingInputClickInModal()"></div>
          }
        </nz-input-group>
      </div>
      <div>
        <label nz-radio [nzValue]="true">Clip (Relative)</label>
        <nz-input-group class="legacy-input-styling" style="padding: 0;">
          <label style="left: 10px;">Clip Relative</label>
          <nz-slider [nzMin]="0" [nzMax]="phasediff_clipValue" [nzStep]="0.01" [nzDisabled]="velocityAuto != true"
            [(ngModel)]="currentPhaseClipping" (ngModelChange)="setPhaseClipping()"></nz-slider>
        </nz-input-group>
      </div>
    </nz-radio-group>
    }
  </ng-container>
</nz-modal>

<div class="scroll-to-button-group">
  <button nz-button (click)="scrollToAnchor('imageDiv')">
    Scroll To Shot
  </button>
</div>